import { LightRow } from "../system/table";

export class InstitutionItem {
  constructor(public value: LightRow) {
  }

  clone(): InstitutionItem {
    return new InstitutionItem(this.value);
  }
}
